export default class ScoreQuestionAnswer {
    constructor({
        questionId = 0,
        answerId = 0
    }) {
        this.questionId = questionId || 0;
        this.answerId = answerId || 0;
    }
}